<template>
  <div class="mt-1">
    <!-- in caricamento la card non c'è e .form-card-wrapper vuoto è nascosto
         (custom.scss): l'altezza va sull'overlay, o il loader finisce sopra la modale -->
    <b-overlay
      center
      :show="isLoading"
      rounded="sm"
      :class="{ 'log-detail--loading': isLoading }"
    >
      <div class="form-card-wrapper">
        <b-card header="true" header-tag="header" v-if="!isLoading">
          <div
            slot="header"
            class="d-flex justify-content-between align-items-center"
          >
            <p class="mb-0 d-inline-block align-middle">
              <b>Dettaglio Log</b>
            </p>
          </div>
          <div>
            <template v-if="data.logObject">
              <div class="grid-custom-wrapper border-bottom">
                <div class="pb-2"><strong>Template ID</strong></div>
                <div class="pb-2">
                  {{ data.logObject.template_id }}
                </div>
              </div>
              <div class="grid-custom-wrapper border-bottom">
                <div class="py-2"><strong>Destinatario</strong></div>
                <div class="py-2">
                  {{ data.logObject.recipient }}
                </div>
              </div>
            </template>
            <div
              v-if="data.resolvedContent.subject"
              class="grid-custom-wrapper border-bottom"
            >
              <div class="py-2"><strong>Oggetto</strong></div>
              <div class="py-2">
                {{ data.resolvedContent.subject }}
              </div>
            </div>
            <div v-if="data.resolvedContent.text" class="grid-custom-wrapper">
              <div class="pt-2"><strong>Testo</strong></div>
              <div class="pt-2" v-html="data.resolvedContent.text"></div>
            </div>
            <div
              v-if="data.resolvedContent.text_content"
              class="grid-custom-wrapper"
            >
              <div class="pt-2"><strong>Testo</strong></div>
              <div class="pt-2 sms-text">
                {{ data.resolvedContent.text_content }}
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import LisaComunicaMixin from "@/mixins/LisaComunicaMixin";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
// import BaseIcon from "@/components/BaseIcon";

export default {
  mixins: [LisaComunicaMixin],
  name: "General",
  props: {
    resourceId: Number,
    // dal dettaglio cliente: il log si legge tramite LisaWeb, che lo mostra a
    // chi vede il cliente e non solo a chi ha fatto l'invio
    registryId: Number,
  },
  components: {
    // BaseIcon,
  },
  data() {
    return {
      isLoading: true,
      id: this.resourceId,
      repository: "log",
      data: null,
    };
  },
  beforeMount() {
    const request = this.registryId
      ? RepositoryFactory.get("registry").communication(this.registryId, this.id)
      : this.show();
    request
      .then((response) => {
        this.data = this.registryId
          ? response.data.data
          : response.data.content;
        this.isLoading = false;
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({
          preset: "error",
          text: `${errMsg}`,
        });
        this.isLoading = false;
        this.ok = true;
      });
  },
};
</script>

<style scoped lang="scss">
.card {
  border: none;
}

.col-md-4.border-bottom {
  text-transform: uppercase;
  color: rgb(63, 60, 60);
  font-weight: bold;
}

.log-detail--loading {
  min-height: 160px;
}

.sms-text {
  white-space: pre-line;
}

:deep(.grid-custom-wrapper) {
  display: grid;
  grid-template-columns: 70px 1fr;
  column-gap: 50px;
  row-gap: 5px;
}
</style>
